import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Typography, Tag, message } from 'antd';
import axios from 'axios';
import { getCompany } from '../../services/companyApi';
import { Link, useParams } from 'react-router-dom';
const { Title, Text, } = Typography;

const ViewCompany = () => {
  const [companies, setCompanies] = useState([]);
const { tenantId } = useParams();
console.log(tenantId,"id tenant")
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await getCompany({tenantId:tenantId})
        setCompanies(res);
      } catch (err) {
        message.error('Failed to fetch companies');
      }
    };
    fetchCompanies();
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <Row gutter={[16, 16]}>
        {companies.map((company) => (
          <Col key={company._id} xs={24} sm={12} md={8} lg={6}>
            <Card
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{company.name}</span>
                  <Tag color={company.isActive ? 'green' : 'red'}>
                    {!company.isActive ? 'Active' : 'Inactive'}
                  </Tag>
                </div>
              }
              bordered
              hoverable
            >
              <Text type="secondary">📍 Location:</Text>
              <div>{company.location || 'N/A'}</div>

              <Text type="secondary">👤 Manager:</Text>
              <div>{company?.manager?.name || 'Not Assigned'}</div>

              {/* <Text type="secondary">💰 Total Revenue:</Text>
              <div>₹ {company.totalRevenue?.toLocaleString() || 0}</div> */}

              <div style={{ marginTop: 12 }}>
                <Link to={`/company/${company._id}`}>See More</Link>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ViewCompany;
